import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  padding: 1rem 0;
  text-align: center;
  font-size: 1.2rem;
`;

const PageRejection = ({ text }) => {
  return <StyledDiv>{text}</StyledDiv>;
};

export default PageRejection;
